import { doc, getDoc } from "firebase/firestore";
import React, { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../utils/firebase"
import { toast } from "react-toastify";
import CryptoJS from 'crypto-js';

// Create context
const AuthContext = createContext();

// Custom hook to use AuthContext
export const useAuth = () => useContext(AuthContext);

// Auth Provider
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem("user");
    //console.log("saved user", savedUser)
    if(savedUser){
      return savedUser;
    }else return null;
  });

   // Decrypt password - for verification purposes
   const SECRET_KEY = process.env.REACT_APP_ENCRYPTION_KEY;

   const decryptPassword = (encryptedPassword) => {
    const bytes = CryptoJS.AES.decrypt(encryptedPassword, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  };



  // Login function
  const login = async (email, password, navigate) => {
    try {
        // Fetch user data from Firestore
        const userDocRef = doc(db, "userDetails", email); // Email is the document ID
        const userDoc = await getDoc(userDocRef);
        //console.log("data redfffff", userDoc)
        if (userDoc.exists()) {
          const userData = userDoc.data();
          //console.log('sdckjbsdc121212', userData)
          //console.log("Sdcsdcsd", decryptPassword(userData.password))
          // Check if the entered password matches Firestore password
          if (decryptPassword(userData.password) === password) {
            setUser({ email, role: userData?.role });
            localStorage.setItem("user", userData?.email);
            if(userData?.role === 'admin'){
              localStorage.setItem("role", 'admin');
            }else{
              localStorage.setItem("role", 'user');
            }
            
            //console.log('sdckjbsdc', userData)
            // Redirect based on role
            if (userData.role === "admin") {
              navigate("/admin");
            } else {
              navigate("/user");
            }
          } else {
            toast.error("Invalid password!");
          }
        } else {
          toast.error("User does not exist!");
        }
      } catch (error ) {
        console.error("Login Error:", error);
        toast.error("Something went wrong, please try again later");
      } 

  };

  useEffect(() => {
    const savedUser = localStorage.getItem("user");
    if (savedUser) {
      setUser(savedUser);
    }
  }, []);

  // Logout function
  const logout = (navigate) => {
    setUser(null);
    localStorage.removeItem("user"); 
    localStorage.removeItem("role");
    navigate("/login");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>

      {children}
    </AuthContext.Provider>
  );
};
